<template>
  <div id="page-product-form">
    <vs-row>
      <vs-col :class="readonly ? 'readonly-form' : ''">
        <vue-element-loading :active="busy"></vue-element-loading>
        <card-page :card-title="cardTitle" :switch-model="model.IsEnabled">
          <vue-form-generator
            ref="form"
            :model="model"
            :options="formOptions"
            :schema="schema"
          />
        </card-page>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import FormModelMixin from '@/components/mixins/FormModelMixin';
import {
  selectOptions,
  datepickerOptions,
  arrayOptions
} from '@/components/form/FormElementOption';
import AdditiveWidget from '@/components/form/fields/AdditiveWidget';
import FormFieldValidationMixin from '@/components/mixins/FormFieldValidationMixin';
import moment from 'moment';
import CardPage from '@/views/components/Views/CardPage';

export default {
  name: 'CompanyTobaForm',
  props: {
    value: {
      type: Object,
      required: true
    },
    cardTitle: {
      type: String,
      required: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    AdditiveWidget,
    CardPage
  },
  mixins: [FormModelMixin, FormFieldValidationMixin],
  data() {
    return {
      selectedReferences: [],
      model: {
        tobas: [],
      },
      schema: {
        groups: [
          {
            styleClasses: 'w-full mt-4',
            fields: [
            {
                type: 'vueMultiSelect',
                styleClasses: 'w-1/3',
                label: 'Status',
                model: 'status',
                values: () => this.statusOptions,
                selectOptions: {
                  showLabels: false,
                  hideSelected: false,
                },
              },
            ],
          },
          {
            styleClasses: 'w-full mt-4',
            fields: [
              {
                type: 'vueMultiSelect',
                styleClasses: 'w-1/3',
                label: 'Type',
                model: 'TOBAType_FK',
                values: () => this.tobaTypeOptions,
                selectOptions,
                required: true,
                validator: 'required',
              },
              {
                visible: () => this.model.status == 'OPEN' || this.model.status == 'CLOSED',
                ...datepickerOptions,
                styleClasses: 'w-1/3',
                label: 'Start Date',
                model: 'StartDate',
                onChanged: () => this.validateField('ExpiryDate'),
                required: true,
                validator: [
                  'required',
                  'string',
                  (value, field, model) => {
                    if (model.ExpiryDate) {
                      let startDate = model.StartDate;
                      let expiryDate = moment(model.ExpiryDate).unix();

                      if (typeof startDate === 'string') {
                        startDate = moment(
                          model.StartDate,
                          'YYYY-MM-DD'
                        ).unix();
                      } else {
                        startDate = startDate / 1000;
                      }

                      if (expiryDate < startDate) {
                        return 'Expiry Date must be after Inception Date.';
                      }
                    }

                    return true;
                  }
                ]
              },
              {
                visible: () => this.model.status == 'CLOSED',
                ...datepickerOptions,
                styleClasses: 'w-1/3',
                label: 'Expiry Date',
                model: 'ExpiryDate',
                onChanged: () => this.validateField('StartDate'),
                required: true,
                validator: [
                  'required',
                  'string',
                  (value, field, model) => {
                    if (model.StartDate) {
                      let startDate = model.StartDate;
                      let expiryDate = moment(model.ExpiryDate).unix();

                      if (typeof startDate === 'string') {
                        startDate = moment(
                          model.StartDate,
                          'YYYY-MM-DD'
                        ).unix();
                      } else {
                        startDate = startDate / 1000;
                      }

                      if (expiryDate < startDate) {
                        return 'Expiry Date must be after Inception Date.';
                      }
                    }

                    return true;
                  }
                ]
              },
              {
                type: 'textArea',
                inputType: 'textArea',
                styleClasses: 'w-full',
                label: 'Note',
                model: 'Note',
                rows: 4
              }
            ]
          }
        ]
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true
      },
      tobaTypeOptions: [],
      statusOptions:[
        'OPEN',
        'CLOSED',
        'NOT APPLICABLE',
      ],
      options: [
        {
          endpoint: () => this.$api.companyToba.getOptions(),
          optionsFieldName: 'tobaTypeOptions',
          nameFieldName: 'Type',
          idFieldName: 'TOBAType_FK'
        }
      ]
    };
  }
};
</script>

<style lang="scss">
</style>
